import { MaterialsFactory } from '../factories/MaterialsFactory';

const THREE = require('three');

class LinesSet extends THREE.Group {
    constructor(color = 0x000000, w = 48, h = 6, f = 0.4, thickness = 1) {
        super();

        this._w = w;
        this._h = h;

        const geom = new THREE.PlaneBufferGeometry(w, thickness);
        const material = MaterialsFactory.create({
            color: new THREE.Color(color)
        });

        material.fog = true;

        const line1 = new THREE.Mesh(geom, material);
        const line2 = new THREE.Mesh(geom, material);

        line1.position.y = h;

        line2.scale.x = f;

        this.add(line1);
        this.add(line2);
    }
}

export default LinesSet;
